export default __webpack_public_path__ + "static/media/logo.aeddbb4c.svg";